import React, { Component } from 'react';
import { Navigate } from 'react-router-dom';
import { styled } from '@mui/system';
import axios from 'axios';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper'; 
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import FormControl from '@mui/material/FormControl'; 
import InputLabel from '@mui/material/InputLabel';   
import Select from '@mui/material/Select';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import { jsPDF } from 'jspdf';
import { autoTable } from 'jspdf-autotable';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Dialog from '@mui/material/Dialog';      
import DialogActions from '@mui/material/DialogActions'; 
import DialogContent from '@mui/material/DialogContent'; 
import DialogTitle from '@mui/material/DialogTitle';   
import psdfimage from './images/psdfimage.png';
let strCust=[{title:'',year:'0'}]; 
export default class Accountspayablereport extends Component {
	 constructor(props) {
    super(props);
	var strdob = new Date();
var month = "";
if ((strdob.getMonth() + 1) < 10) {
    month = "0" + (strdob.getMonth() + 1);
} else {
    month = (strdob.getMonth() + 1);
}
 this.state = { 
 open:false,
	 ColumnData:[],todate1: strdob.getFullYear() + '-' + month + '-' + (strdob.getDate()), todate: new Date(strdob.getFullYear(), strdob.getMonth(), 1),
redirect:false,pagename:'',sinid:'',CustomerData:[] ,id:'',page:0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
search:'',order:'desc' ,orderBy:'',vendid:'',
	 Vendorbilldata:[],totalrecords:0,selectedcount:0,vendorarrauto:[],custsort:'total_due desc',selectedvendorexchange:[],veid:'',		
	}
	  this.onTagsvendorexchange = this.onTagsvendorexchange.bind(this);   
	}
componentWillMount() {
	document.title = "Isifol - Sales Invoice";	
 if(localStorage.getItem("ISIuserid")==null)
		  {
		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
		if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {	
 this.ColumheaderinvoiceApi();
this.apicall(this.state.page,this.state.rowsPerPage); 	  
		  }
		  else{	    
		this.PageAccessCheckApi();
         }
}
	 let strname="Accounts Payable (A/P) Aging Report";
	 this.props.parentdasCallback(
            strname+"~"
        );	
}
PageAccessCheckApi() {
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=30')
  .then(resp => {
	  let strreturn=resp.data;
      if (strreturn!==0) {
       this.ColumheaderinvoiceApi();
this.apicall(this.state.page,this.state.rowsPerPage); 	
      } else {
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
  });
}	
myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 } 	
ColumheaderinvoiceApi(){
	axios.get(localStorage.getItem("ISIurl")+'ajaxbusinesssetting.php?action=getall&bs_cmp_id='+localStorage.getItem("ISIcmpid")+'&bs_id=7&bs_page=1')
  .then(resp => {  	
    if(resp.data.length>0){
			this.setState({  
			  ColumnData: resp.data,  
			   colcount:parseInt(resp.data[0].count),
			});
     }
    });
}
onloadVendorBind=(event)=>{
     axios.get(localStorage.getItem("ISIurl")+'ajaxvendors.php?action=vendorextender&ve_cmp_id='+localStorage.getItem("ISIcmpid")+'&ve_contactname='+event.target.value)
      .then((resp) => {
        if (resp.data.length > 0) {
          var rowsArrayc = resp.data;
          rowsArrayc.map((row) => {
            const items = {
              title:row.ve_contactname,
              year: row.ve_id,
            };
const cufound = strCust.some(el => el.year === row.year);
		 if (!cufound) strCust.push(items)
       //  strCust.push(items);
            this.setState({ vendorarrauto: strCust });
          });
        } else {
          this.setState({ vendorarrauto:strCust });
        }
      });
};
onInputVendChange = (event, newTextValue) => {
	if(newTextValue!==" "){
	  this.setState({vendid:newTextValue})
	} 
}
onTagsvendorexchange = (event, values) => {
	if(values!==" " && values!==null && values.rowindex!="-1"){
		this.setState({
		vendid:values.year,
		 veid:values.year,
		selectedvendorexchange:values})
	}
	else
	{
		 this.setState({ vendid:'',ve_id:'',selectedvendorexchange:[]})
	}
}
  todatehandler = (date) => {
    var month = "";
    var dateObj = new Date(date);
       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }
    this.setState({
       todate: dayjs(dateObj),
        todate1: dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  }
	apicall(page,rowsPerPage){
	 axios.get(localStorage.getItem("ISIurl")+'ajaxaccountsrecievablereport.php?action=payeblereportgetall&todate='+this.state.todate1+'&vb_cmp_id='+localStorage.getItem("ISIcmpid")+'&vb_ve_id='+this.state.veid+'&StartIndex='+page+'&PageSize='+rowsPerPage+'&sorting='+this.state.custsort)
  .then(resp => {  
    if(resp.data.length>0){
			this.setState({  
			  Vendorbilldata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   totalrecords:parseInt(resp.data[0].count),
		    });
			let copy=[50, 100, 150, 200, 250]
	  this.setState({rowsPaging:copy});
     }
	 else{
		   this.setState({Vendorbilldata:[],totaldata:0});
	 }
    });
}
handleClickSearch=()=>{
 this.apicall(this.state.page,this.state.rowsPerPage); 
}
 handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };
    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    }; 
handleExportClick = (event) => {
  this.setState({ anchorEl: event.currentTarget });
};
handleClose = () => {
  this.setState({ anchorEl: null });
};
handleExportPDF = () => {
  this.handleDownload();
  this.handleClose();
};
handleExportCSV = () => {
  document.getElementById("test-table-xls-button").click();
  this.handleClose();
};
handleClickOpen = () => {
      this.GetLogoForpdf();
  };
GetLogoForpdf() {
  axios
    .get(`${localStorage.getItem("ISIurl")}ajaxbusinesssetting.php`, {
      params: {
        action: "getpdflogo",
        bs_cmp_id: localStorage.getItem("ISIcmpid"),
        bs_id: 2,bs_page:5
      },
    })
    .then((resp) => {
      if (resp.data.status === "success") {
        this.setState(
          {
            pdflogo: resp.data.base64,
          },
          () => {
            setTimeout(() => {
              this.handleDownload();
            }, 500);
          }
        );
      } else {
        console.error("Error:", resp.data.message);
      }
    })
    .catch((error) => {
      console.error("Request failed:", error);
    });
}  
handleDownload = () => {
  const { Vendorbilldata, ColumnData } = this.state;
  const doc = new jsPDF();
  const imgWidth = 40;
  const imgHeight = 12;
  const imgX = (doc.internal.pageSize.width - imgWidth) / 2;
  const imgY = 10;
 if (this.state.pdflogo) {
	 const logoImage = this.state.pdflogo.startsWith('data:image')
      ? this.state.pdflogo
      : `data:image/jpeg;base64,${this.state.pdflogo}`;
  doc.addImage(logoImage, 'JPEG', imgX, imgY, imgWidth, imgHeight);
 }
  const title = 'Accounts Payable A/R Aging Report';
  doc.setFontSize(16);
  const titleY = imgY + imgHeight + 8;
  doc.text(title, doc.internal.pageSize.width / 2, titleY, { align: 'center' });
  const tableStartY = titleY + 10;
  const dynamicHeaders = ColumnData.flatMap(col =>
    col.bs_value.split(',').map(val => '<' + val.trim())
  );
  const agingColumns = Object.keys(Vendorbilldata[0] || {})
    .filter(key => key.startsWith('due_'))
    .sort((a, b) => {
      const getNum = key => parseInt(key.match(/\d+/)?.[0] || '9999', 10);
      return getNum(a) - getNum(b);
    });
  const headers = [['Vendor', 'Credit Limit', 'O/S Amt', ...dynamicHeaders, 'Older']];
  const rows = Vendorbilldata.map(item => [
    item.vendorname,
    parseFloat(item.ve_creditlimit || 0).toFixed(2),
    parseFloat(item.total_due || 0).toFixed(2),
    ...agingColumns.map(col => parseFloat(item[col] || 0).toFixed(2))
  ]);
  const totalRow = [
    '',
    '',
    Vendorbilldata.reduce((sum, item) => sum + parseFloat(item.total_due || 0), 0).toFixed(2),
    ...agingColumns.map(col =>
      Vendorbilldata.reduce((sum, item) => sum + parseFloat(item[col] || 0), 0).toFixed(2)
    )
  ];
  rows.push(totalRow);
  doc.autoTable({
    head: headers,
    body: rows,
    startY: tableStartY,
    theme: 'striped',
    didDrawPage: function (data) {
      const str = "Page " + doc.internal.getNumberOfPages();
      doc.setFontSize(10);
      doc.text(str, doc.internal.pageSize.width / 2, doc.internal.pageSize.height - 10, { align: 'center' });
    }
  });
  doc.save('AccountsPayableAgingReport.pdf');
  this.handleCloseExportDialog();
};
		    handleOpenExportDialog = () => {
        this.setState({ openExportDialog: true });
    };
    handleCloseExportDialog = () => {
        this.setState({ openExportDialog: false });
    };
 render() { 
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
  if (
    !this.state.Vendorbilldata || 
    this.state.Vendorbilldata.length === 0
  ) {
    return <div>Loading...</div>;
  }
  const agingColumns = Object.keys(this.state.Vendorbilldata[0])
    .filter(key => key.startsWith('due_'))
    .sort((a, b) => {
      const getNum = key => parseInt(key.match(/\d+/)?.[0] || '9999', 10);
      return getNum(a) - getNum(b);
    });
const totalRow = {
  totalDue: 0,
  agingTotals: {}
};
this.state.Vendorbilldata.forEach(item => {
  totalRow.totalDue += parseFloat(item.total_due || 0);
  agingColumns.forEach(col => {
    if (!totalRow.agingTotals[col]) {
      totalRow.agingTotals[col] = 0;
    }
    totalRow.agingTotals[col] += parseFloat(item[col] || 0);
  });
});
  return (
		<React.Fragment> 
		<div className="searchbox">
		<ul>
		<li  style={{ width: '20%' }} >
		<p>&nbsp;</p>
		<p>
		<Autocomplete
  fullWidth
  inputValue={this.state.vendid}
  className="txtbox" 
  options={this.state.vendorarrauto}  
  onInputChange={this.onInputVendChange}
  onChange={this.onTagsvendorexchange}
value={this.state.selectedvendorexchange}  
  renderInput={(params) => (
    <TextField 
      {...params} 
      onChange={this.onloadVendorBind}  
      name="custtitle"   
      variant="outlined" 
      fullWidth
      placeholder="Search vendor"
	  className="txtbox"
    />
  )}
  getOptionLabel={(option) => option.title || ""}
/>
	</p>
</li>
<li>
<p><p>To Date</p>
<LocalizationProvider dateAdapter={AdapterDayjs}>
<DemoContainer components={['DatePicker']}>
<DatePicker
value= {dayjs(this.state.todate1) }
className="txtbox"
onChange={this.todatehandler} format="MM/DD/YYYY"
/>  </DemoContainer>
    </LocalizationProvider> </p></li>
	<li>
	<p><p>Sort by</p><Select
  native
  variant="outlined" className="txtbox"
  margin="normal"
  fullWidth 
  onChange={this.myChangeHandler}
  id="custsort"
  value={this.state.custsort}
  name="custsort"
  inputProps={{tabIndex: "4"}}
        ><option value="total_due desc">Outstanding Amount</option>
	<option value="vendorname Asc">Name</option>
  </Select></p>
	</li>
	<li><p>&nbsp;</p>
	<p className="searchbutton">
			<Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
			 Calculate 
			</Button>
			&nbsp;&nbsp;
			<a className="detailed" href="#/Accountspayabledetailesreport"><Button type="submit" variant="contained" className="frmSecondarybtn" onClick={this.handleClickSearch}>
			 Detailed 
			</Button></a>
			&nbsp;&nbsp;
			<Button variant="contained" color="primary" className="exportbtn" onClick={this.handleOpenExportDialog} > EXPORT
             </Button>
	</p>
</li>
</ul>
</div>
<div className="clear"></div>
<div className="">
<Paper >
<TableContainer >  
<Table id="payableagingexport" stickyHeader aria-label="sticky table">
 <TableHead>
         <TableRow>
		 <TableCell>Vendor</TableCell>
		 <TableCell>Credit Limit</TableCell>
		 <TableCell>O/S Amt</TableCell>
            {this.state.ColumnData.map((col, index) => 
      col.bs_value.split(',').map((val, i) => (
        <TableCell key={index + '-' + i}>{'<' + val}</TableCell>
      ))
    )}
	<TableCell>Older</TableCell>
          </TableRow>
        </TableHead>
  <TableBody>
  {this.state.totaldata !== 0 ? (
    <React.Fragment>
      {this.state.Vendorbilldata.map((item, index) => (
        <TableRow key={index}>
<TableCell>
  <a
    className="link"
    href={"#/Vendorviewmore?veid=" + item.ve_id}
  >
    {item.vendorname}
  </a>
</TableCell>

<TableCell>
  <a
    className="link"
    href={"#/Vendorviewmore?veid=" + item.ve_id}
  >
    {'\u200B' +parseFloat(item.ve_creditlimit || 0).toFixed(2)}
  </a>
</TableCell>

<TableCell>
  <a
    className="link"
    href={"#/Vendorviewmore?veid=" + item.ve_id}
  >
    {parseFloat(item.total_due || 0).toFixed(2)}
  </a>
</TableCell>

{agingColumns.map((col, colIndex) => (
  <TableCell key={colIndex}>
    <a
      className="link"
      href={"#/Vendorviewmore?veid=" + item.ve_id}
    >
      {parseFloat(item[col] || 0).toFixed(2)}
    </a>
  </TableCell>
))}
        </TableRow>
      ))}
	  <TableRow key="total-row">
  <TableCell />
  <TableCell /> 
  <TableCell><strong>{totalRow.totalDue.toFixed(2)}</strong></TableCell>
  {agingColumns.map((col, index) => (
    <TableCell key={"total-" + index}>
      <strong>{totalRow.agingTotals[col].toFixed(2)}</strong>
    </TableCell>
  ))}
</TableRow>
    </React.Fragment>
  ) : (
    <TableRow key="no-data">
      <TableCell align="center" colSpan={this.state.colcount}>
        No Records
      </TableCell>
    </TableRow>
  )}
</TableBody>
</Table>
  </TableContainer> 
  <Table id="agingreport"  style={{ display: 'none' }}> 
 <TableHead>
         <TableRow>
		 <TableCell>Customer</TableCell>
		 <TableCell>Credit Limit</TableCell>
		 <TableCell>O/S Amt</TableCell>
            {this.state.ColumnData.map((col, index) => 
      col.bs_value.split(',').map((val, i) => (
        <TableCell key={index + '-' + i}>{'<' + val}</TableCell>
      ))
    )}
	<TableCell>Older</TableCell>
          </TableRow>
        </TableHead>
  <TableBody>
  {this.state.totaldata !== 0 ? (
    <React.Fragment>
      {this.state.Vendorbilldata.map((item, index) => (
        <TableRow key={index}>
		<TableCell>{item.vendorname}</TableCell>
		<TableCell>{'\u200B' +parseFloat(item.ve_creditlimit || 0).toFixed(2)}</TableCell>
		<TableCell>{'\u200B' + parseFloat(item.total_due || 0).toFixed(2)}</TableCell>
          {agingColumns.map((col, colIndex) => (
            <TableCell key={colIndex}>{'\u200B' + parseFloat(item[col] || 0).toFixed(2)}</TableCell>
          ))}
        </TableRow>
      ))}
	  <TableRow key="total-row">
  <TableCell />
  <TableCell /> 
  <TableCell><strong>{'\u200B' + parseFloat(totalRow.totalDue || 0).toFixed(2)}</strong></TableCell>
  {agingColumns.map((col, index) => (
    <TableCell key={"total-" + index}>
      <strong>{'\u200B' + parseFloat(totalRow.agingTotals?.[col] || 0).toFixed(2)}</strong>
    </TableCell>
  ))}
</TableRow>
    </React.Fragment>
  ) : (
    <TableRow key="no-data">
      <TableCell align="center" colSpan={this.state.colcount}>
        No Records
      </TableCell>
    </TableRow>
  )}
</TableBody>
</Table>  
  </Paper>
 </div>
<Dialog open={this.state.openExportDialog} onClose={this.handleCloseExportDialog}>
                    <DialogTitle>Accounts Payable A/R Aging Report</DialogTitle>
                    <DialogContent>
					<p> To generate a new report, based on the latest selection criteria you've specified, choose the format 
					you want to use. Depending on the amount of data included on the report, it may take some time to generate.</p>
				 <p style={{ textAlign: "center", display: "flex", justifyContent: "center", gap: "20px" }}>
					<ReactHTMLTableToExcel
    id="test-table-xls-button"
    className="my-custom-excel-button"
    table="agingreport"
    filename="Payable A/P Aging Report"
    sheet="Payable A/P Aging Report"
    buttonText=""
    variant="contained"
/>
<img src={psdfimage} width={100} height={100} style={{ cursor: "pointer" }} onClick={this.handleClickOpen} alt="Download PDF" /></p>
</DialogContent>
<DialogActions>
<Button onClick={this.handleCloseExportDialog} color="primary"> Cancel </Button>
</DialogActions>
</Dialog>
</React.Fragment> 
 )
 }
}